module.exports = __webpack_public_path__ + "img/white-and-grey-bedspread-3264493.37eb6643.jpg";